// const firebaseConfig = {
//   apiKey: "AIzaSyBAI5SFfYHWMOtMVamb3mZxqLDLQ0jQGRM",
//   authDomain: "fir-project-50eb0.firebaseapp.com",
//   databaseURL: "https://fir-project-50eb0.firebaseapp.com",
//   projectId: "fir-project-50eb0",
//   storageBucket: "fir-project-50eb0.appspot.com",
//   messagingSenderId: "1035712184725",
//   appId: "1:1035712184725:web:d9f768b68a39f3b366f69c",
//   measurementId: "G-MJY35VSY7T",
// };

// omnicure - qa
// export const firebaseConfig = {
//   apiKey: "AIzaSyAIUS0bTsHYHtZDLtiY8gviJOZPBj7eEZI",
//   authDomain: "omnicure-qa.firebaseapp.com",
//   databaseURL: "https://omnicure-qa.firebaseio.com",
//   projectId: "omnicure-qa",
//   storageBucket: "omnicure-qa.appspot.com",
//   messagingSenderId: "139244279471",
//   appId: "1:139244279471:web:3e82e02a6811dd802ee65a",
//   measurementId: "G-X0HR7XJ4HW",
// };

//QA-omnicure
// export const firebaseConfig = {
//   apiKey: "AIzaSyDLmPi6ZB8LVzsO0GMSsAqQvEjdKEVMxIU",
//   authDomain: "qa-omnicure.firebaseapp.com",
//   databaseURL: "https://qa-omnicure.firebaseio.com",
//   projectId: "qa-omnicure",
//   storageBucket: "qa-omnicure.appspot.com",
//   messagingSenderId: "699680151510",
//   appId: "1:699680151510:web:c072a699783faea863b677",
//   measurementId: "G-H4WCYHYB47",
//   speechToTextURL:
//     "https://streaming-speech-to-text-dot-qa-omnicure.uc.r.appspot.com/",
// };

// dev environment

export const firebaseConfig = {
  apiKey: "AIzaSyB0ciCKAxKu37vGUbl6gBNSb0fC5Ff44a0",
  authDomain: "dev-omnicure.firebaseapp.com",
  databaseURL: "https://dev-omnicure.firebaseio.com",
  projectId: "dev-omnicure",
  storageBucket: "dev-omnicure.appspot.com",
  messagingSenderId: "462063129427",
  appId: "1:462063129427:web:d1fb129ea379d30441c7a6",
  measurementId: "G-7CMWQ1D0HX",
  speechToTextURL:
    "https://streaming-speech-to-text-dot-dev-omnicure.uc.r.appspot.com",
};

// export const firebaseConfig = {
//   apiKey: "AIzaSyD4X2ixYuZLvlgLRaevyoSKXdROj3wHr-8",
//   authDomain: "omnicure-staging.firebaseapp.com",
//   databaseURL: "https://omnicure-staging.firebaseio.com",
//   projectId: "omnicure-staging",
//   storageBucket: "omnicure-staging.appspot.com",
//   messagingSenderId: "983814465722",
//   appId: "1:983814465722:web:80d21ea182c925e4eaba83",
//   measurementId: "G-P3ZRLTHK4W",
// };

// export const firebaseConfig = {
//   apiKey: "AIzaSyDc99LhFtQqDgvp30O1r2iINh-GyqUwUX4",
//   authDomain: "omnicure-test.firebaseapp.com",
//   databaseURL: "https://omnicure-test-default-rtdb.firebaseio.com",
//   projectId: "omnicure-test",
//   storageBucket: "omnicure-test.appspot.com",
//   messagingSenderId: "780167717438",
//   appId: "1:780167717438:web:79c4e6d8d48e572afce76f",
//   measurementId: "G-D4QGG22DL9"
// };

// QA - Omnicure
// export const firebaseConfig = {
//   apiKey: "AIzaSyDLmPi6ZB8LVzsO0GMSsAqQvEjdKEVMxIU",
//   authDomain: "qa-omnicure.firebaseapp.com",
//   databaseURL: "https://qa-omnicure.firebaseio.com",
//   projectId: "qa-omnicure",
//   storageBucket: "qa-omnicure.appspot.com",
//   messagingSenderId: "699680151510",
//   appId: "1:699680151510:web:c072a699783faea863b677",
//   measurementId: "G-H4WCYHYB47",
// };

//production -omnicure
// const firebaseConfig = {
//   apiKey: "AIzaSyAq29k0mWfGgOV-mrBYdaktd4TGe0FyraI",
//   authDomain: "omnicure.firebaseapp.com",
//   databaseURL: "https://omnicure.firebaseio.com",
//   projectId: "omnicure",
//   storageBucket: "omnicure.appspot.com",
//   messagingSenderId: "493079331956",
//   appId: "1:493079331956:web:0d29ed98e40c4b5c53fd21",
//   measurementId: "G-CELWVQCHJ1"
// };
